import { RouterProvider } from "react-router-dom";
import router from "./routes/router.tsx";
import { Provider } from "react-redux";
import en from "@shopify/polaris/locales/en.json";
import { AppProvider } from "@shopify/polaris";
import store from "./store/store/store.ts";
import AuthWrapper from "./components/atoms/AuthWrapper.tsx";
import Link from "./components/molecules/LinkOverride.tsx";
import { useState, useEffect } from "react";

function App() {
  const [theme, setTheme] = useState<'light' | 'dark-experimental'>(
    (localStorage.getItem('theme') === 'dark' ? 'dark-experimental' : 'light')
  );

  console.log(
    "Team BookEase is thrilled to simplify your order booking journey! 📦✨"
  );

  useEffect(() => {
    const handleThemeChange = (e: CustomEvent) => {
      const newTheme =
        e.detail.value === "dark" ? "dark-experimental" : "light";
      setTheme(newTheme);
    };
  
    window.addEventListener("themeChanged", handleThemeChange as EventListener);
  
    return () => {
      window.removeEventListener("themeChanged", handleThemeChange as EventListener);
    };
  }, []);
  

  return (
    <>
      <Provider store={store}>
        <AppProvider i18n={en} linkComponent={Link} theme={theme}>
          <AuthWrapper>
            <RouterProvider router={router} />
          </AuthWrapper>
        </AppProvider>
      </Provider>
    </>
  );
}

export default App;